import * as React from "react";
let Logo ="login.png";

export default class PanelEmail extends React.Component <{}> {
  constructor(props) {
    super(props);
    
    this.handleChange = this.handleChange.bind(this);
    //permet de disable le bouton next
    this.props.onChange(undefined);
   
  }
  
  componentDidMount () {
		setTimeout(function(){
    
    const node = document.querySelectorAll('button');
    node.forEach(element => {
      //console.log(element);
      const item=element.querySelectorAll('span')
      if(item[0]!= undefined)if(item[0].innerHTML=="Next")item[0].innerHTML="Etape suivante";
      if(item[0]!= undefined)if(item[0].innerHTML=="Back")item[0].innerHTML="Etape précédente";
      
     // console.log(item);
    });
  },0);
 
    //const node2=node.querySelectorAll('button');
    
  }
 
  
  handleChange(e) {
   // console.log(e.target.value);
    this.props.onChange(e.target);
  }

  render() {
    const{...state}=this.props;
    return (
      <div style={{padding:'10px'}}>
        <h3>{state.etape}</h3>
        <p>Entrez une adresse Email  </p>
        <div>
          <img height="250" src={Logo} /> 
        </div>
        <div style={{margin:'-20px 0 50px 0'}}>
        <p>Entrez votre identifiant </p>
        <input style={{fontSize:'16px'}}id='step2' type="text" onChange={this.handleChange} placeholder="nom.prenom"/>
        </div>
      </div>
    );
  }
}
